import { useSelector } from 'react-redux'
import { selectConfig } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useModuleNotifications from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/useModuleNotifications'

interface ContractsOfTheDay {
  contracts: { id: number | string }[]
}

const useHistoricSalesNotifications = (groupedContractsByDate: ContractsOfTheDay[], visible: boolean) => {
  const { contactId }: { contactId?: number | string | null } = useSelector(selectConfig)

  useModuleNotifications({
    moduleKey: 'historic-sales',
    scope: contactId,
    items: groupedContractsByDate.flatMap(({ contracts }) => contracts.map(contract => String(contract.id))),
    visible,
  })
}

export default useHistoricSalesNotifications
